import React from 'react'
import ReactDOMServer from 'react-dom/server'
import PeopleDoorDuotone from '@convious/icons/src/icons/duotone/peopleDoorDuotone.svg'
import PeopleRoofDuotone from '@convious/icons/src/icons/duotone/peopleRoofDuotone.svg'
import TimesIconSolid from '@convious/icons/src/icons/solid/timesSolid.svg'
import { TimelineItem, TimelineGroup } from '../types'
import { t } from 'translations'

const svgToString = (SvgComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>): string => {
    return ReactDOMServer.renderToStaticMarkup(<SvgComponent />)
}

const doorIcon = svgToString(PeopleDoorDuotone)
const roofIcon = svgToString(PeopleRoofDuotone)
const timesIcon = svgToString(TimesIconSolid)

const getGroupTemplate = (group: TimelineGroup): string => {
    if (!group) return ''
    return `
        <div>
            ${group.reservationPeriodType === 'Gate' ? doorIcon : roofIcon}
            ${group.content}
        </div>
    `
}

const getPeriodItemTemplate = (item: TimelineItem): string => {
    return `
        <div>
            <strong>${t('orders.capacityReport.item.reserved', { reserved: String(item.reserved) })}</strong>
            <span>${t('orders.capacityReport.item.remaining', { available: String(item.available) })}</span>
        </div>
    `
}

const getInstantItemTemplate = (item: TimelineItem): string => {
    return `
        <div>
            <strong>${item.available}</strong>
        </div>
    `
}

const getIconItemTemplate = (icon: string, text: string): string => {
    return `
        <div>
            ${icon}
            <span>${text}</span>
        </div>
    `
}

const getItemTemplate = (item: TimelineItem): string => {
    if (item.reservationType === 'instant') {
        return getInstantItemTemplate(item)
    }
    if (item.capacity === 0) {
        return getIconItemTemplate(timesIcon, t('orders.capacityReport.closed'))
    }
    if (item.capacity === null) {
        return getIconItemTemplate(timesIcon, t('orders.capacityReport.unlimited'))
    }
    return getPeriodItemTemplate(item)
}

export { getItemTemplate, getGroupTemplate }
